module.exports = __webpack_public_path__ + "img/zs-mpro.b6c9cf23.png";